import React, { Component } from "react";
import * as d3 from "d3";
import $ from "jquery";
import d3Tip from "d3-tip";
import PropTypes from "prop-types";
import moneyFormatter from "../../common/moneyFormatter";
import "./groupBar.style.scss";

class GroupBarchart2 extends Component {
  state = {
    display: {
      m: { t: 20, b: 30, r: 30, l: 40 },
    },
  };
  componentDidMount() {
    const { display } = this.state;
    const {
      data,
      toolTipPercent,
      yAxisText,
      textOnTopOfBar,
      dollar,
      containerWidth,
      height,
      targetDiv,
    } = this.props;
    this.drawChart({
      display,
      data,
      toolTipPercent,
      yAxisText,
      textOnTopOfBar,
      dollar,
      containerWidth,
      height,
      targetDiv,
    });
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.containerWidth !== this.props.containerWidth ||
      JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)
    ) {
      const { display } = this.state;
      const {
        data,
        toolTipPercent,
        yAxisText,
        textOnTopOfBar,
        dollar,
        containerWidth,
        height,
        targetDiv,
      } = nextProps;
      $(`#${this.props.targetDiv}`).empty();
      this.drawChart({
        display,
        data,
        toolTipPercent,
        yAxisText,
        textOnTopOfBar,
        dollar,
        containerWidth,
        height,
        targetDiv,
      });
    }
  }
  componentWillUnmount() {
    d3.selectAll(".d3-tip").remove();
  }

  drawChart = ({
    display,
    data,
    toolTipPercent,
    yAxisText,
    textOnTopOfBar,
    dollar,
    containerWidth,
    height,
    targetDiv,
  }) => {
    if (data.length <= 0) {
      return;
    }

    let m = display.m,
      w = containerWidth - m.l - m.r,
      h = height - m.t - m.b;

    let xScale = d3.scale.ordinal().rangeRoundBands([0, w], 0.5);
    let yScale = d3.scale.linear().range([h, 0]);
    let x1 = d3.scale.ordinal();

    let xAxis = d3.svg.axis().scale(xScale).innerTickSize(0).orient("bottom");

    let yAxis1 = d3.svg
      .axis()
      .scale(yScale)
      .orient("left")
      .ticks(6)
      .innerTickSize(-w)
      .outerTickSize(0);
    // .ticks(10, "%");

    // without y axis name
    let yAxis2 = d3.svg
      .axis()
      .scale(yScale)
      .orient("left")
      .ticks(6)
      .innerTickSize(-w)
      .outerTickSize(0)
      .tickFormat("");

    let yAxis = yAxisText === false ? yAxis2 : yAxis1;

    let groupRect = d3.keys(data[0]).filter(function (key) {
      return key !== "metric_name" && key !== "groupRect";
    });

    let Data = data.forEach(function (d) {
      d.groupRect = groupRect.map(function (name) {
        return { name: name, value: +d[name] };
      });
    });

    xScale.domain(data.map((d) => d.metric_name));

    x1.domain(groupRect).rangeRoundBands([0, xScale.rangeBand()]);

    yScale
      .domain([
        d3.min(data, function (d) {
          return d3.min(d.groupRect, function (d) {
            if (d.value > 0) return 0;
            else {
              return d.value;
            }
          });
        }),
        d3.max(data, function (d) {
          return d3.max(d.groupRect, function (d) {
            if (d.value < 0) return 0;
            else {
              return d.value;
            }
          });
        }),
      ])
      .nice();

    let svg = d3
      .select(`#${targetDiv}`)
      .append("svg")
      .attr("height", h + m.t + m.b)
      .attr("width", w + m.l + m.r)
      .attr("class", "barchart");

    if (svg) {
      let Color = d3.scale.ordinal().range(["#81efde", "#4c6ead", "#8775a7"]);

      // tool tip defined here
      var tip = d3Tip()
        .attr("class", "d3-tip")
        .offset([-10, 0])
        .html(function (d) {
          let withPercent = `<strong class="text-capitalize">${
            d.name.toLowerCase() == "funds" ? "Portfolio" : d.name
          } : </strong> <span style='color:white'> ${d.value.toFixed(
            2
          )}% </span>`;

          let withoutPercent = `<strong class="text-capitalize">${
            d.name.toLowerCase() == "funds" ? "Portfolio" : d.name
          } : </strong> <span style='color:white'> ${
            dollar ? moneyFormatter(d.value) : d.value.toFixed(2)
          } </span>`;

          let displayTooltip =
            toolTipPercent == false ? withoutPercent : withPercent;

          return displayTooltip;
        });

      svg.call(tip);

      var chart = svg
        .append("g")
        .attr("transform", (d) => `translate(${m.l},${m.t - 15})`);

      {
        data.length > 12
          ? chart
              .append("g")
              .attr("class", "x axis")
              .attr("transform", (d) => `translate(${0},${h})`)
              .call(xAxis)
              //text rotating 40 degree
              .selectAll("text")
              .style("text-anchor", "end")
              .attr("font-size", "2px")
              .attr("dx", "0em")
              .attr("dy", ".813em")
              .attr("transform", function (d) {
                return "rotate(-35)";
              })
          : chart
              .append("g")
              .attr("class", "x axis")
              .attr("transform", (d) => `translate(${0},${h})`)
              .call(xAxis);
      }
      chart
        .append("g")
        .attr("class", "y axis")
        .call(yAxis)
        .call((g) => g.select(".domain").remove());

      const holder = svg
        .append("g")
        .attr("transform", (d) => `translate(${m.l},${m.t - 15})`)
        .selectAll(".groups")
        .data(data)
        .enter()
        .append("g")
        .attr("class", "groups")
        .attr("transform", function (d) {
          return `translate(${xScale(d.metric_name)},${0})`;
        });

      holder
        .selectAll("rect")
        .data((d) => d.groupRect)
        .enter()
        .append("rect")
        .attr("Value", (d) => d.value)
        .attr("Name", (d) => d.name)
        .attr("rx", 8)
        .attr("ry", 8)
        .attr("x", (d) => x1(d.name))
        // .attr("y", (d) => yScale(0))
        .attr("width", x1.rangeBand())
        // .attr("height", function (d) {
        //   return null;
        // })
        .attr("y", (d) => {
          if (d.value >= 0) {
            return yScale(d.value);
          } else {
            return yScale(0);
          }
        })
        .attr("height", function (d) {
          return Math.abs(yScale(d.value) - yScale(0));
        })
        .style("fill", function (d) {
          return Color(d.name);
        })
        .on("mouseover", tip.show)
        .on("mouseout", tip.hide);

      // animation with height and y proper value
      // holder
      //   .selectAll("rect")
      //   .transition()
      //   // .delay(d => Math.random() * 1000)
      //   .delay(1000)
      //   .duration(1000)
      //   .ease("linear")
      //   .attr("y", function (d) {
      //     if (d.value >= 0) {
      //       return yScale(d.value);
      //     } else {
      //       return yScale(0);
      //     }
      //   })
      //   .attr("height", function (d) {
      //     return Math.abs(yScale(d.value) - yScale(0));
      //   });
      svg
        .selectAll(".y,.x")
        .transition()
        .duration(500)
        .delay(1300)
        .style("opacity", "1");

      // text on top of bar chart
      textOnTopOfBar === true
        ? holder
            .append("g")
            .append("text")
            .attr("class", "centerLabel")
            .text(function (d) {
              var txt = d.Savings ? d.Savings : d.investment;
              return moneyFormatter(txt);
            })
            .attr("x", "-70")
            .attr("y", function (d) {
              return yScale(0) - 70;
            })
            // .attr("dy", function(d,i) {
            //   return yScale(0) / 2;
            //   // return  Math.abs(yScale(d.value) - yScale(0))
            // })
            //  .attr("dx", x1.rangeBand() / 4)
            .attr("transform", function (d) {
              return `rotate(270,5,${yScale(0) - 88})`;
            })
        : null;
    }
  };

  render() {
    return <div id={this.props.targetDiv} />;
  }
}

GroupBarchart2.propTypes = {
  height: PropTypes.number.isRequired,
  containerWidth: PropTypes.number.isRequired,
  targetDiv: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
};
export default GroupBarchart2;



// WEBPACK FOOTER //
// ./src/components/d3Components/NewBarchart/GroupBarchart.js